import { MutationTree } from 'vuex';
import { IFieldState } from '@signing-page/fields/store/field.store';
import { IField } from '@/fields/types/field';

export const mutationSetLoading = 'setLoading';
export const mutationSetFields = 'setFields';
export const mutationSetPageWidth = 'setPageWidth';
export const mutationUpdateField = 'updateField';

export const mutations: MutationTree<IFieldState> = {
  [mutationSetLoading](state: IFieldState, loading: boolean) {
    state.loading = loading;
  },
  [mutationSetFields](state: IFieldState, fields: IField[]) {
    state.fields = fields;
  },
  [mutationSetPageWidth](state: IFieldState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [mutationUpdateField](state: IFieldState, field) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.id === field.id ? field : stateField
    );
  },
};
